// extracted by mini-css-extract-plugin
export default {"loadingAnimation":"Loader_loadingAnimation__i1OyK","normal":"Loader_normal__MFa0D","loading-animation":"Loader_loading-animation__ojzfX","small":"Loader_small__ZIhMu"};